const shadows = [
  "none",
  "0px 1px 2px 0px rgba(10, 13, 18, 0.05)",
  "0px 1px 8px 0px rgba(0, 0, 0, 0.04), 0px 1px 2px 0px rgba(0, 0, 0, 0.01)",
  "0px 1px 2px 0px rgba(10, 13, 18, 0.06), 0px 1px 3px 0px rgba(10, 13, 18, 0.1)",
  "0px 2px 2px 2px rgba(0, 0, 0, 0.01), 0px 4px 8px 0px rgba(0, 0, 0, 0.12)",
  "0px 4px 5px 2px rgba(0, 0, 0, 0.02), 0px 6px 8px 4px rgba(0, 0, 0, 0.02)",
  "0px 8px 8px -4px rgba(10, 13, 18, 0.03), 0px 20px 24px -4px rgba(10, 13, 18, 0.08)",
  "0px 24px 48px -12px rgba(10, 13, 18, 0.18)",
  "0px 32px 64px -12px rgba(10, 13, 18, 0.14)",
];

export default shadows;
